import { Icon } from "Components";
import { DEFAULT_WHITELIST_URL } from "../PhishingManager.constants";

const WhiteListing = () => <div className="pm-info-banner">
    <div className="pm-info-content">
        <div className="pm-info-row">
            <div className="pm-info-icon-wrapper">
                <div className="pm-info-icon">
                    <Icon type="campaignInfo" />
                </div>
            </div>

            <div className="pm-info-text-group">
                <div className="pm-info-title">
                    Configure Whitelisting for Successful Campaigns
                </div>
                <div className="pm-info-description">
                    To ensure phishing simulations are delivered, clients must whitelist
                    Venza’s email infrastructure. This step allows campaigns to be
                    accessible and prevents client-side security controls from blocking
                    email delivery.
                </div>
            </div>
        </div>
    </div>

    <div className="pm-info-action">
        <a
            href={DEFAULT_WHITELIST_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="pm-info-action-text"
        >
            View Whitelisting Guide
        </a>
    </div>

</div>

export default WhiteListing;